import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_TEST_CONNECTION } from 'api/utilityActionTypes';

export default async function testRentManagerConnection(
  { state, utilityApiClient },
  { companyCode, onSuccess, onError },
) {
  typeCheck('companyCode::NonEmptyString', companyCode);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_TEST_CONNECTION,
    queryId: companyCode,
    state: state,
    payload: {
      companyCode,
    },
    onSuccess: onSuccess,
    onError: onError,
  });
}
